<template>
  <div class="space-y-6">
    <div class="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <div class="text-sm font-semibold text-slate-700">Security</div>
        <h2 class="mt-1 text-2xl font-bold tracking-tight text-slate-900">Audit logs</h2>
      </div>
      <div class="rounded-lg bg-white px-3 py-2 text-xs text-slate-600 ring-1 ring-slate-200">
        Total: <span class="font-semibold text-slate-900">{{ logs.length }}</span>
      </div>
    </div>

    <div class="rounded-2xl bg-white p-4 ring-1 ring-slate-200">
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <input
          v-model.trim="q"
          placeholder="Search logs… (plate, action, message)"
          class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm outline-none ring-sky-200 focus:ring-4 sm:max-w-md"
        />
        <button class="rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-50" @click="clear">
          Clear logs
        </button>
      </div>

      <div class="mt-4 overflow-x-auto rounded-xl ring-1 ring-slate-200">
        <table class="w-full min-w-[820px] text-left text-xs">
          <thead class="bg-slate-50 text-slate-600">
            <tr>
              <th class="px-3 py-2 font-semibold">Time</th>
              <th class="px-3 py-2 font-semibold">Actor</th>
              <th class="px-3 py-2 font-semibold">Action</th>
              <th class="px-3 py-2 font-semibold">Message</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="l in filtered.slice(0, 200)" :key="l.id" class="border-t border-slate-200">
              <td class="px-3 py-2 text-slate-600">{{ dt(l.at) }}</td>
              <td class="px-3 py-2 text-slate-600">{{ actorName(l.actorId) }} <span class="text-slate-400">({{ l.actorRole || "-" }})</span></td>
              <td class="px-3 py-2 font-mono text-slate-700">{{ l.action }}</td>
              <td class="px-3 py-2 text-slate-700">{{ l.message }}</td>
            </tr>
            <tr v-if="filtered.length === 0">
              <td class="px-3 py-8 text-center text-slate-500" colspan="4">No logs.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-3 text-xs text-slate-500">
        Showing up to 200 latest matches.
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { toast } from "@/toast";

const store = useStore();
const q = ref("");

const logs = computed(() => store.state.auditLogs);
const filtered = computed(() => {
  const query = q.value.toLowerCase();
  if (!query) return logs.value;
  return logs.value.filter((l) => {
    const blob = `${l.action} ${l.message} ${(l.meta && JSON.stringify(l.meta)) || ""}`.toLowerCase();
    return blob.includes(query);
  });
});

function actorName(id) {
  return store.state.staffUsers.find((u) => u.id === id)?.name || "—";
}

function dt(iso) {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

function clear() {
  store.state.auditLogs = [];
  toast.info("Logs cleared.");
}
</script>

